// Client quotes from the previous site. brand is set only where the quote
// itself names the brand. Arabic text is a first draft for review.
export const testimonials = [
  {
    name: 'Ibraam',
    brand: 'Fimka',
    quote: {
      en: 'ShopFlex Studios truly understood the essence of Fimka from day one. They translated our vision into a modern, feminine website that feels elegant, smooth, and effortless to shop.',
      ar: 'فهم فريق ShopFlex جوهر Fimka منذ اليوم الأول، وحوّل رؤيتنا إلى موقع عصري بلمسة أنثوية، أنيق وسلس وسهل التسوّق.',
    },
  },
  {
    name: 'Alaa',
    brand: 'Q-San Luxury',
    quote: {
      en: 'The site feels calm, clean, and elegant, exactly the vibe we wanted for Q-San Luxury. Customers love how easy it is to browse and shop.',
      ar: 'الموقع هادئ ونظيف وأنيق، وهو بالضبط الإحساس الذي أردناه لـ Q-San Luxury. العملاء يحبّون سهولة التصفّح والتسوّق.',
    },
  },
  {
    name: 'Celine',
    quote: {
      en: 'They really listened to what we wanted and turned it into something even better than we imagined. The site looks amazing and it’s fast.',
      ar: 'استمعوا فعلاً لما نريده وحوّلوه إلى شيء أفضل مما تخيّلنا. الموقع رائع وسريع.',
    },
  },
  {
    name: 'Mayar',
    quote: {
      en: 'They totally got our streetwear vision and built a site that feels bold, confident, and super easy to use.',
      ar: 'فهموا رؤيتنا لأزياء الشارع تماماً، وبنوا موقعاً جريئاً وواثقاً وسهل الاستخدام جداً.',
    },
  },
  {
    name: 'Adham',
    quote: {
      en: 'We wanted a raw, street-inspired vibe and ShopFlex Studios nailed it. The site feels bold, fast, and speaks directly to our audience.',
      ar: 'أردنا روحاً خاماً مستوحاة من الشارع، ونجحت ShopFlex في ذلك تماماً. الموقع جريء وسريع ويخاطب جمهورنا مباشرة.',
    },
  },
  {
    name: 'Minoura',
    quote: {
      en: 'I asked for something simple, clean, and easy to manage. What they delivered was exactly that: minimal, elegant, and on-brand from top to bottom.',
      ar: 'طلبت شيئاً بسيطاً ونظيفاً وسهل الإدارة، وهذا بالضبط ما قدّموه: بسيط وأنيق ومتّسق مع العلامة من أوله لآخره.',
    },
  },
  {
    name: 'Fareda',
    quote: {
      en: 'ShopFlex Studios transformed our vision into a stunning Shopify store. The attention to detail and mobile optimisation exceeded our expectations.',
      ar: 'حوّلت ShopFlex رؤيتنا إلى متجر شوبيفاي مذهل. الاهتمام بالتفاصيل وتهيئة الجوال فاقا توقّعاتنا.',
    },
  },
  {
    name: 'Dina',
    quote: {
      en: 'The team understood our brand perfectly. The website captures our bold aesthetic while being incredibly user-friendly.',
      ar: 'فهم الفريق علامتنا تماماً. الموقع يعكس طابعنا الجريء وفي الوقت نفسه سهل الاستخدام للغاية.',
    },
  },
];
